// Assistant role (mode) resolution — single source of truth, kept pure so it can
// be unit-tested (reload / history persistence regressions). The 3 consolidated
// roles are the only valid modes; legacy ids map safely onto them.

export const VALID_MODES = ["assistant", "strategy", "support"];

// Backward-compatibility: legacy role ids (from old conversations, stored state
// or external entry points) map onto the 3 consolidated roles.
export const LEGACY_MODE_MAP = {
  calendar: "assistant",
  advisor: "strategy",
  statistics: "strategy",
  reflection: "support",
  motivator: "support",
};

// Coerce any incoming id onto a valid consolidated role, or null when it can't
// be resolved. Never throws; safe for unknown/empty input.
export const normalizeMode = (m) => {
  if (!m) return null;
  const mapped = LEGACY_MODE_MAP[m] || m;
  return VALID_MODES.includes(mapped) ? mapped : null;
};

// Resolve the initial role on (re)mount. Priority: react-router history.state
// (survives reload + carries per-entry back/forward mode) → localStorage fallback
// → null (show role-select). Returns null only when NO valid role can be found.
export function resolveInitialMode({ stateMode, storedMode } = {}) {
  return normalizeMode(stateMode) || normalizeMode(storedMode) || null;
}
